import NotImplementedEditor from "./NotImplementedEditor"

export default NotImplementedEditor
